// 封装一些用的API，不用把URL写在页面中，直接调用即可
import http from './request.js'

// 设置个对象，就不用一个个暴露了，直接暴露对象
// 在页面引用的时候就可以用apiFun.方法的方式
const apiFun = {}
apiFun.getConsumStatisList = function (params) {
    return http.get('/sqmv1/apiv1/av39', params)
}
apiFun.getOperationList = function (params) {
    return http.get('/sqmv1/apiv1/av42', params)
}
apiFun.getRechargeList = function (params) {
    return http.get('/sqmv1/apiv1/av41', params)
}
apiFun.getConsumptionList = function (params) {
    return http.get('/sqmv1/apiv1/av40', params)
}
apiFun.getSmsChannelList = function (params) {
    return http.get('/sqmv1/ss/s1', params)
}
apiFun.addSmsChannel = function (params) {
    return http.post('/sqmv1/ss/s2', params)
}
apiFun.editSmsChannel = function (id, params) {
    return http.post('/sqmv1/ss/s3?id=' + id, params)
}
apiFun.delSmsChannel = function (id) {
    return http.get('/sqmv1/ss/s4?id=' + id)
}
apiFun.smsChannelFenPei = function (params) {
    return http.post('/sqmv1/ss/s5', params)
}
apiFun.smsFenPeiList = function (params) {
    return http.get('/sqmv1/ss/s13', params)
}
apiFun.getSmsYunList = function () {
    return http.get('/sqmv1/ss/s12')
}
apiFun.smsTemplateList = function (params) {
    return http.get('/sqmv1/ss/s6', params)
}
apiFun.AddsmsTemplate = function (params) {
    return http.post('/sqmv1/ss/s7', params)
}
apiFun.EditsmsTemplate = function (id, params) {
    return http.post('/sqmv1/ss/s8?id=' + id, params)
}
apiFun.DelsmsTemplate = function (id) {
    return http.get('/sqmv1/ss/s9?id=' + id)
}
apiFun.getStatiList = function () {
    return http.get('/sqmv1/ss/s14')
}
apiFun.getBackRobot = function (id) {
    return http.get('/sqmv1/bb/b9', id)
}
// 修改密码
apiFun.editPwd = function (params) {
    return http.post('sqmv1/bb/b12', params)
} // 修改密码
apiFun.seatsStates = function (params) {
    return http.post('sqmv1/bb/b13', params)
}
// ASR识别下发列表
apiFun.getTelAsrList = function (params) {
    return http.get('/sqmv1/ee/e9', params)
}
// ASR识别下发
apiFun.telAsrSend = function (data) {
    return http.post('/sqmv1/ee/e10', data)
}
// ASR识别取消下发
apiFun.telAsrCancel = function (data) {
    return http.post('/sqmv1/ee/e11', data)
}
// ASR识别类型列表
apiFun.getTelAsrTypeList = function () {
    return http.get('/sqmv1/ee/e12')
}
// 获取所有子账号
apiFun.getSubAccount = function (data) {
    return http.post('/sqmv1/bb/b14', data)
}
export default apiFun
